import React from "react";
import Header from "../components/Header";
import {
  AboutMission,
  AboutusBanner,
  AboutusClients,
} from "../components/AboutusComp";
import Footer from "../components/Footer";

const Aboutuspage = () => {
  return (
    <>
    <title>About Us</title>
      <Header />
      <AboutusBanner />
      <AboutMission />
      <AboutusClients />
      <Footer />
    </>
  );
};

export default Aboutuspage;
